import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Typography,
  CircularProgress,
  Paper,
  ListItem,
  ListItemText,
  Divider,
  Box,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { Link } from "react-router-dom";

function ShowAllWorkflows() {
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWorkflows = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/workflows/all`
        );
        setWorkflows(response.data.workflows);
      } catch (err) {
        setError(err.message);
        enqueueSnackbar("Failed to load workflows", { variant: "error" });
      } finally {
        setLoading(false);
      }
    };

    fetchWorkflows();
  }, []);

  if (loading) return <CircularProgress />;
  if (error)
    return (
      <Typography color="error" variant="body1">
        {error}
      </Typography>
    );

  return (
    <Box sx={{ padding: 2, width: "65%", margin: "auto" }}>
      <Typography variant="h4" gutterBottom color="text.primary" align="center">
        All Workflows
      </Typography>
      {workflows.length === 0 ? (
        <Typography component="span" variant="body1" color="text.secondary">
          No workflows available.
        </Typography>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {workflows.map((workflow) => {
            const startEntityNode = workflow.nodes.find(
              (node) => node.id === workflow.startEntity
            );

            const finalEntitiesNames = workflow.finalEntities
              .map((finalId) => {
                const node = workflow.nodes.find((n) => n.id === finalId);
                return node ? node.name : "Unknown";
              })
              .join(", ");

            return (
              <Paper
                key={workflow._id}
                variant="outlined"
                sx={{
                  padding: 2,
                  width: "100%",
                  maxWidth: "600px",
                  margin: "auto",
                }}
              >
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant="h6" color="primary">
                        <Link
                          to={`/admin/workflows/${workflow._id}`}
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                            cursor: "pointer",
                          }}
                        >
                          {workflow.title}
                        </Link>
                      </Typography>
                    }
                    secondary={
                      <>
                        <Typography color="text.primary">
                          <strong>Start Approver:</strong>{" "}
                          {startEntityNode ? startEntityNode.name : "Unknown"}
                        </Typography>
                        <Typography color="text.primary">
                          <strong>Final Approvers:</strong> {finalEntitiesNames}
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
                <Divider />
              </Paper>
            );
          })}
        </Box>
      )}
    </Box>
  );
}

export default ShowAllWorkflows;
